import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Commentaire } from '../models/Commentaire';


@Injectable({
  providedIn: 'any'
})
export class CommentaireService {

  private apiUrl = environment.urlBackend;

  constructor(private http: HttpClient) {}

  // Récupérer tous les commentaires
  getAll(): Observable<Commentaire[]> {
    return this.http.get<Commentaire[]>(`${this.apiUrl}commentaires`);
  }

  // Récupérer les commentaires d’un client
  getByClient(codeDivalto: string): Observable<Commentaire[]> {
    return this.http.get<Commentaire[]>(`${this.apiUrl}commentaires/client/${codeDivalto}`);
  }

  // Créer un commentaire
  create(commentaire: Commentaire): Observable<Commentaire> {
    return this.http.post<Commentaire>(`${this.apiUrl}commentaires`, commentaire);
  }

  // Mettre à jour un commentaire
  update(commentaire: Commentaire): Observable<Commentaire> {
    if (!commentaire.id) throw new Error('L’ID est requis pour la mise à jour');
    return this.http.put<Commentaire>(`${this.apiUrl}commentaires/${commentaire.id}`, commentaire);
  }

  // Supprimer un commentaire
  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}commentaires/${id}`);
  }
}
